import http from '../../../utils/fetch';
export default {
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscHhptAgentType/selectListPage',
            method: 'post',
            params: query
        });
    },

    getAgent(query) {
        return http({
            url: '/api/swyl/v1/demo/bscHhptAgentType/getAgent?username='+query,
            method: 'post',
        });
    },

    saveOrUpdate(query) {
        return http({
            url: '/api/swyl/v1/demo/bscHhptAgentType/saveOrUpdate',
            method: 'post',
            params: query
        });
    },
    delOrRes(query) {
        return http({
            url: '/api/swyl/v1/demo/bscHhptAgentType/delOrRes',
            method: 'post',
            params: query
        });
    },

}
